import "@/public/styles/globals.css";
import Layout from "@/components/Layout/Index";
import QuickTracking from "@/components/Common/QuickTracking/Index";
import { appWithTranslation } from "next-i18next";
import nextI18NextConfig from "@/next-i18next.config";
import type { AppProps } from "next/app";
import { Provider } from "react-redux";
import { wrapper } from "@/store";
import { PersistGate } from "redux-persist/integration/react";
import { useAppDispatch } from "@/store/hooks";
import { setSite } from "@/store/app";
import { useEffect } from "react";
import { adoptHandOffEarly } from "@/utils/crossSiteHandoff";

// 跨站交接的登录态要在任何页面请求发出前写进 cookie，见 utils/crossSiteHandoff.ts
adoptHandOffEarly();

// ✅ 注册所有图标（默认 + mobile）
declare const require: {
  context(
    path: string,
    deep?: boolean,
    filter?: RegExp
  ): __WebpackModuleApi.RequireContext;
};

const requireAll = (r: __WebpackModuleApi.RequireContext) => r.keys().forEach(r);

requireAll(require.context("../src/icons", false, /\.svg$/));
requireAll(require.context("../src/icons/mobile", false, /\.svg$/));

function SiteInit() {
  const dispatch = useAppDispatch();
  useEffect(() => {
    fetch("/pointsmall/api/env")
      .then((res) => res.json())
      .then((data) => {
        dispatch(setSite(data.site));
      });
  }, [dispatch]);
  return null;
}

function MyApp({ Component, pageProps }: AppProps) {
  const { store, props } = wrapper.useWrappedStore(pageProps);
  // 页面组件设置 noLayout = true 时跳过全局 Header/Footer
  const noLayout = (Component as any).noLayout === true;
  return (
    <Provider store={store}>
      {/* @ts-ignore 此处对应store/index.ts中store.__persistor的设置 */}
      <PersistGate persistor={store.__persistor}>
        <SiteInit />
        <QuickTracking />
        {noLayout ? (
          <Component {...pageProps} />
        ) : (
          <Layout>
            <Component {...pageProps}></Component>
          </Layout>
        )}
      </PersistGate>
    </Provider>
  );
}

export default appWithTranslation(MyApp, nextI18NextConfig);
